import get from 'lodash/get';

export const errorsSelector = (state: Record<string, any>) => state.errors.errors;
